export const QuestionTypeText = 0
export const QuestionTypeRadio = 1
export const QuestionTypeList = 2
export const QuestionTypeCheckbox = 3
export const QuestionTypeLongText = 4
export const QuestionTypeUserKind = 5
export const QuestionTypeMultipleChoice = 6
export const QuestionTypeEmail = 7
export const QuestionTypeNumber = 8
export const QuestionTypeImageUpload = 9
export const TypeYesNo = 10
export const QuestionTypePassword = 11
export const QuestionTypeAcknowledgement = 12

const QuestionTypes = [QuestionTypeText, QuestionTypeRadio, QuestionTypeList, QuestionTypeCheckbox, QuestionTypeLongText, QuestionTypeUserKind, QuestionTypeMultipleChoice, QuestionTypeEmail, QuestionTypeNumber, QuestionTypeImageUpload, TypeYesNo, QuestionTypePassword, QuestionTypeAcknowledgement]

export default {
  data: function () {
    return {
      QuestionTypeText,
      QuestionTypeRadio,
      QuestionTypeList,
      QuestionTypeCheckbox,
      QuestionTypeLongText,
      QuestionTypeUserKind,
      QuestionTypeMultipleChoice,
      QuestionTypeEmail,
      QuestionTypeNumber,
      QuestionTypeImageUpload,
      TypeYesNo,
      QuestionTypePassword,
      QuestionTypeAcknowledgement,
      QuestionTypes
    }
  }
}
